// src/components/PersonEditModal.jsx
// Modal za uređivanje osobe i arhiviranje (brisanje)

import React, { useState, useEffect } from 'react';
import '../css/PersonForm.css';

function PersonEditModal({ isOpen, person, firms = [], onSave, onArchive, onClose }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [lozinka, setLozinka] = useState('');
  const [city, setCity] = useState('');
  const [firmId, setFirmId] = useState('default');
  const [glovoId, setGlovoId] = useState('');
  const [woltId, setWoltId] = useState('');
  const [vozilo, setVozilo] = useState('');
  const [vlasnik, setVlasnik] = useState('');
  const [registracija, setRegistracija] = useState('');
  const [startMonth, setStartMonth] = useState(1);
  const [startYear, setStartYear] = useState(new Date().getFullYear());

  useEffect(() => {
    if (person && isOpen) {
      setName(person.name || '');
      setEmail(person.email || '');
      setLozinka(person.lozinka || '');
      setCity(person.city || '');
      setFirmId(person.firmId || 'default');
      setGlovoId(person.glovoId || '');
      setWoltId(person.woltId || '');
      setVozilo(person.vozilo || '');
      setVlasnik(person.vlasnik || '');
      setRegistracija(person.registracija || '');
      setStartMonth(person.startMonth ?? new Date().getMonth() + 1);
      setStartYear(person.startYear ?? new Date().getFullYear());
    }
  }, [person, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const selectedFirmObj = firms.find((f) => f.id === firmId);
    if (!selectedFirmObj) {
      alert('Odabrana firma ne postoji.');
      return;
    }
    const emailNorm = (email || '').trim().toLowerCase();
    onSave({
      ...person,
      name: name.trim(),
      email: emailNorm,
      emailLower: emailNorm,
      lozinka: lozinka.trim() || '',
      city: city.trim() || '',
      firmId,
      glovoId: glovoId.trim() || '',
      woltId: woltId.trim() || '',
      vozilo: vozilo.trim() || '',
      vlasnik: vlasnik.trim() || '',
      registracija: registracija.trim() || '',
      startMonth,
      startYear,
    });
    onClose();
  };

  const handleArchive = () => {
    if (!window.confirm(`Arhivirati osobu "${person?.name}"? Neće se više prikazivati u aktivnoj listi.`)) {
      return;
    }
    onArchive(person);
    onClose();
  };

  if (!isOpen || !person) return null;

  return (
    <div className="person-form-sati">
      <h2>Uredi osobu</h2>
      <form onSubmit={handleSubmit} className="person-form">
        <div className="form-group">
          <label>Ime*:</label>
          <input
            type="text"
            placeholder="Ime"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Email*:</label>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Lozinka*:</label>
          <input
            type="text"
            placeholder="Lozinka"
            value={lozinka}
            onChange={(e) => setLozinka(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Grad:</label>
          <input
            type="text"
            placeholder="Grad"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Firma*:</label>
          <select value={firmId} onChange={(e) => setFirmId(e.target.value)} required>
            {firms.map((firm) => (
              <option key={firm.id} value={firm.id}>
                {firm.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Glovo ID:</label>
          <input
            type="text"
            placeholder="Glovo ID"
            value={glovoId}
            onChange={(e) => setGlovoId(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Wolt ID:</label>
          <input
            type="text"
            placeholder="Wolt ID"
            value={woltId}
            onChange={(e) => setWoltId(e.target.value)}
          />
        </div>
        <div className="person-extra-section">
          <h3 className="person-extra-section-title">Podaci o vozilu</h3>
          <div className="form-group">
            <label>VOZILO:</label>
            <input
              type="text"
              placeholder="npr. Skuter"
              value={vozilo}
              onChange={(e) => setVozilo(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>VLASNIK:</label>
            <input
              type="text"
              placeholder="Vlasnik"
              value={vlasnik}
              onChange={(e) => setVlasnik(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>REGISTRACIJA:</label>
            <input
              type="text"
              placeholder="Registracija"
              value={registracija}
              onChange={(e) => setRegistracija(e.target.value)}
            />
          </div>
        </div>
        <div className="form-group">
          <label>Početni mjesec*:</label>
          <select
            value={startMonth}
            onChange={(e) => setStartMonth(parseInt(e.target.value))}
            required
          >
            {[...Array(12)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Početna godina*:</label>
          <select
            value={startYear}
            onChange={(e) => setStartYear(parseInt(e.target.value))}
            required
          >
            {Array.from({ length: new Date().getFullYear() - 2022 + 2 }, (_, i) => 2022 + i).map(
              (year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              )
            )}
          </select>
        </div>
        <div className="button-group person-edit-buttons">
          <button type="submit" className="save-button">
            Spremi
          </button>
          <button type="button" onClick={handleArchive} className="archive-button">
            Arhiviraj osobu
          </button>
          <button type="button" onClick={onClose} className="cancel-button">
            Odustani
          </button>
        </div>
      </form>
    </div>
  );
}

export default PersonEditModal;
